const FaqSearch = (function () {
  const $faqForm = $("#faq-listing-page-search-form");
  const $faqInput = $("#faq-listing-page-search");
  const $faqGroups = $(".js-faq-group");
  const $faqItems = $(".js-faq-item");
  const $faqClearBtn = $(".js-faq-listing-page-search-reset");
  const $faqNoHitsMessage = $(".js-faq-no-result-message");

  let nbrOfVisibleItemsGlobal = $faqItems.length;
  let nbrOfVisibleItemsInGroup: number;

  function init() {
    $(function () {
      searchOnInputChange();
      handleClearClick();
      handleSubmit();
    });
  }

  function searchOnInputChange() {
    $faqInput.on("input", function () {
      const val = $(this).val();
      if (typeof val === "string" && val.length >= 3) {
        executeSearch(prepareStringForComparing(val));
      } else {
        restoreFaqListingPage();
      }
    });
  }

  function handleClearClick() {
    $faqClearBtn.on("click", function () {
      restoreFaqListingPage();
      $faqInput.trigger("focus");
    });
  }

  function handleSubmit() {
    $faqForm.on("submit", function (e) {
      e.preventDefault();
      if (nbrOfVisibleItemsGlobal === 0) {
        $faqInput.trigger("focus");
      } else {
        const $firstOpenItem = $faqItems.filter(":not(.is-hidden)").first();
        scrollDownToItem($firstOpenItem);
        if (
          nbrOfVisibleItemsGlobal === 1 &&
          !$firstOpenItem.hasClass("item-expanded")
        ) {
          $firstOpenItem.find(".js-click-to-toggle").trigger("click");
        }
      }
    });
  }

  function executeSearch(searchQuery: string) {
    nbrOfVisibleItemsGlobal = 0;
    $faqGroups.each(function () {
      nbrOfVisibleItemsInGroup = 0;
      const $faqItemsInGroup = $(this).find($faqItems);
      $faqItemsInGroup.each(function () {
        const searchQueryExistsInItem = faqItemIncludesSearchQuery(
          $(this),
          searchQuery,
        );
        if (searchQueryExistsInItem) {
          $(this).show().removeClass("is-hidden");
          nbrOfVisibleItemsGlobal++;
          nbrOfVisibleItemsInGroup++;
        } else {
          $(this).hide().addClass("is-hidden");
        }
      });
      if (nbrOfVisibleItemsInGroup === 0) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });
    if (nbrOfVisibleItemsGlobal === 0) {
      $faqNoHitsMessage.show();
    } else {
      $faqNoHitsMessage.hide();
    }
  }

  function faqItemIncludesSearchQuery(
    $item: JQuery<HTMLElement>,
    searchQuery: string,
  ) {
    const questionParsed = prepareStringForComparing(
      $item.find(".js-faq-question").text(),
    );
    const answerParsed = prepareStringForComparing(
      $item.find(".js-faq-answer").text(),
    );
    return (
      questionParsed.includes(searchQuery) || answerParsed.includes(searchQuery)
    );
  }

  function prepareStringForComparing(str: string) {
    return str.replace(/[^A-Z0-9]/gi, "").toLowerCase();
  }

  function scrollDownToItem($item: JQuery<HTMLElement>) {
    const headerHeight = $("header").innerHeight()!;
    if ($item.length) {
      $("html, body").animate(
        {
          scrollTop: $item.offset()!.top - headerHeight,
        },
        400,
      );
    }
  }

  function restoreFaqListingPage() {
    $faqGroups.show();
    $faqItems.show().removeClass("is-hidden");
    $faqNoHitsMessage.hide();
    nbrOfVisibleItemsGlobal = $faqItems.length;
  }

  return {
    init,
  };
})();

export default FaqSearch;
